import BasicRepository, {ListArgs} from "./basicRepository";
import Client from "../client";
import {DeploymentResource} from "client/resources";
import {TaskState} from "../resources/taskState";

interface DeploymentListArgs extends ListArgs {
    projects?: string[];
    environments?: string[];
    tenants?: string[];
    channels?: string[];
    taskState?: TaskState;
}

class DeploymentRepository extends BasicRepository<DeploymentResource, DeploymentResource, DeploymentListArgs> {
    constructor(client: Client) {
        super("Deployments", client);
    }
}

export default DeploymentRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/deploymentRepository.ts